import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
const CloseInvestAccountModalContent = ({ onClose }) => {
    const handleClose = useCallback((close) => () => {
        onClose(close);
        Modal.hide();
    }, [onClose]);
    return (<View style={styles.contentContainer}>
      <Spacer h={16}/>
      <Text TextThin-14 Secondary centered>
        If you close your investment account, you won’t be able to reopen it for 3 months.
      </Text>
      <Spacer h={32}/>
      <Button brandReversed title="Yes, I am sure" onPress={handleClose(true)}/>
      <Spacer h={8}/>
      <Button brand title="No, I’ll keep my account" onPress={handleClose(false)}/>
    </View>);
};
const CloseInvestAccountModal = {
    show: (onClose) => {
        Modal.show(<CloseInvestAccountModalContent onClose={onClose}/>, {
            containerStyle: styles.modal,
            title: 'Are you sure? 🧸',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    contentContainer: {
        paddingHorizontal: rem(16),
    },
});
export default CloseInvestAccountModal;
